import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "../MainCalculators";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Box,
    Snackbar,
    Alert,
    Button
} from '@mui/material';
const TITLE = "Tasbih Counter App - FREE Online Tally Counter";
const DESCRIPTION = "Use our FREE online Tasbih Counter app (Tally Counter) to keep track of your dhikr and istighfar easily. No downloads or ads, just a simple and effective digital tally counter for your spiritual needs.";
const KEYWORDS = "tally counter, dhikr counter, tasbih counter, electronic tasbih, online istighfar counter, tasbih counter no download, digital dhikr counter";
const OG_URL = "https://do-calculate.com/calculator/en/tally-counter/";
const TallyCounterEN = () => {
    const [state, setState] = useState(() => {
        const savedCounts = JSON.parse(localStorage.getItem("countsEN")) || {};
        const savedCustom = JSON.parse(localStorage.getItem("customTasbihatEN")) || [];
        const savedGoals = JSON.parse(localStorage.getItem("tasbeehGoalsEN")) || {};
        return {
            counts: {
                astaghfirullah: savedCounts.astaghfirullah || 0,
                alhamdulillah: savedCounts.alhamdulillah || 0,
                subhanallah: savedCounts.subhanallah || 0,
                laIlahaIllallah: savedCounts.laIlahaIllallah || 0,
                allahuAkbar: savedCounts.allahuAkbar || 0,
                combined4Tasbeehat: savedCounts.combined4Tasbeehat || 0,
                salawat: savedCounts.salawat || 0,
                subhanAllah: savedCounts.subhanAllah || 0,
                laIlahaIllallah2: savedCounts.laIlahaIllallah2 || 0,
                ...savedCounts
            },
            customTasbeehat: savedCustom,
            goals: savedGoals
        };
    });
    const [showModal, setShowModal] = useState(false);
    const [showGoalModal, setShowGoalModal] = useState(false);
    const [currentGoalTasbeeh, setCurrentGoalTasbeeh] = useState("");
    const [goalValue, setGoalValue] = useState("");
    const [newTasbeeh, setNewTasbeeh] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    // Function to play goal achievement sound
    const playGoalSound = () => {
        try {
            // Create audio context
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            // Create oscillator for the sound
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            // Configure the sound (celebratory beep)
            oscillator.frequency.value = 800; // Frequency in Hz
            oscillator.type = 'sine';
            // Volume envelope
            gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
            // Play sound
            oscillator.start(audioContext.currentTime);
            oscillator.stop(audioContext.currentTime + 0.5);
        } catch (error) {
            console.log('Audio play failed:', error);
        }
    };
    useEffect(() => {
        localStorage.setItem("countsEN", JSON.stringify(state.counts));
        localStorage.setItem("customTasbihatEN", JSON.stringify(state.customTasbeehat));
        localStorage.setItem("tasbeehGoalsEN", JSON.stringify(state.goals));
    }, [state]);
    const handleIncrement = (key) => {
        setState(prev => {
            const newCount = (prev.counts[key] || 0) + 1;
            const newState = {
                ...prev,
                counts: {
                    ...prev.counts,
                    [key]: newCount
                }
            };
            if (prev.goals[key] && newCount >= prev.goals[key]) {
                if (newCount === prev.goals[key]) {
                    playGoalSound(); // Play sound when goal is reached
                    setSnackbarMessage(`Congratulations! You've reached your goal of ${prev.goals[key]} dhikr!`);
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                }
            }
            return newState;
        });
    };
    const handleDecrement = (key) => {
        setState(prev => ({
            ...prev,
            counts: {
                ...prev.counts,
                [key]: Math.max((prev.counts[key] || 0) - 1, 0)
            }
        }));
    };
    const handleReset = (key) => {
        setState(prev => ({
            ...prev,
            counts: {
                ...prev.counts,
                [key]: 0
            }
        }));
    };
    const handleAddTasbeeh = () => {
        if (newTasbeeh.trim() === "") return;
        const key = `custom_${Date.now()}`;
        const formattedKey = key.replace(/\s+/g, '_');
        setState(prev => ({
            ...prev,
            customTasbeehat: [...prev.customTasbeehat, { title: newTasbeeh, key: formattedKey }],
            counts: {
                ...prev.counts,
                [formattedKey]: 0
            }
        }));
        setNewTasbeeh("");
        setShowModal(false);
    };
    const handleRemoveTasbeeh = (key) => {
        setState(prev => {
            const newCounts = { ...prev.counts };
            const newGoals = { ...prev.goals };
            delete newCounts[key];
            delete newGoals[key];
            return {
                ...prev,
                customTasbeehat: prev.customTasbeehat.filter(item => item.key !== key),
                counts: newCounts,
                goals: newGoals
            };
        });
    };
    const handleRemoveGoal = (key) => {
        setState(prev => {
            const newGoals = { ...prev.goals };
            delete newGoals[key];
            return {
                ...prev,
                goals: newGoals
            };
        });
    };
    const handleSetGoal = (key) => {
        setCurrentGoalTasbeeh(key);
        setGoalValue(state.goals[key] || "");
        setShowGoalModal(true);
    };
    const handleSaveGoal = () => {
        if (!goalValue || isNaN(goalValue)) return;
        setState(prev => ({
            ...prev,
            goals: {
                ...prev.goals,
                [currentGoalTasbeeh]: parseInt(goalValue)
            }
        }));
        setShowGoalModal(false);
        setGoalValue("");
        setCurrentGoalTasbeeh("");
    };
    const defaultTasbeehat = [
        { title: "Astaghfirullah (I seek forgiveness from Allah)", key: "astaghfirullah" },
        { title: "Alhamdulillah (All praise is due to Allah)", key: "alhamdulillah" },
        { title: "Subhanallah (Glory be to Allah)", key: "subhanallah" },
        { title: "La ilaha illallah (There is no god but Allah)", key: "laIlahaIllallah" },
        { title: "Allahu Akbar (Allah is the Greatest)", key: "allahuAkbar" },
        { title: "Subhanallah - Alhamdulillah - La ilaha illallah - Allahu Akbar", key: "combined4Tasbeehat" },
        { title: "Allahumma salli 'ala Muhammad (O Allah, send blessings upon Muhammad)", key: "salawat" },
        { title: "Subhanallah wa bihamdihi, Subhanallah al-Azeem", key: "subhanAllah" },
        { title: "La ilaha illallah wahdahu la sharika lah, lahu al-mulk wa lahu al-hamd wa huwa 'ala kulli shay'in qadir", key: "laIlahaIllallah2" },
    ];
    const allTasbeehat = [...defaultTasbeehat, ...state.customTasbeehat];
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: "50px" }}>
                        <h1 style={{ fontSize: "17px" }}>
                            Dhikr Counter - Electronic Tasbih
                        </h1>
                    </div>
                    <div className="border border-light shadow-lg p-4 rounded" style={{
                        backgroundColor: "#f8f9fa",
                        borderRadius: "10px",
                        boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                    }}>
                        <div className="row">
                            <div>
                                <p>
                                    The Dhikr Counter or Tasbih Counter is an electronic tool that helps you count your dhikr and istighfar.
                                    You can easily use this digital counter by clicking on the circle to record each dhikr,
                                    and you can also reset the counter with a single click on the reset button.{" "}
                                    <b>
                                        Your counter is automatically saved even if you refresh or close the page,
                                        so you can continue from where you left off.
                                    </b>{" "}
                                    This tool is ideal for facilitating the process of dhikr and increasing focus during worship.
                                    You can also use this counter to set specific goals for your dhikr.
                                </p>
                                <b>Some of the dhikr you can use with this counter:</b>
                                <ul>
                                    {defaultTasbeehat.map(item => (
                                        <li key={item.key}>{item.title}</li>
                                    ))}
                                </ul>
                                <p>
                                    You can also add your own custom dhikr by clicking the "Add Your Dhikr" button below.
                                </p>
                                <div className="my-3">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowModal(true)}
                                    >
                                        Add Your Dhikr
                                    </button>
                                </div>
                            </div>
                        </div>
                        {allTasbeehat.map((item) => (
                            <div className="row" key={item.key} style={{ paddingBottom: "15px" }}>
                                <div className="col calculatorStyle">
                                    <div className="p-3 mb-2 bg-success text-white text-center">
                                        <h2 style={{ fontSize: "24px" }}>{item.title}</h2>
                                        {state.customTasbeehat.some(t => t.key === item.key) && (
                                            <button
                                                className="text-white px-4 py-2 btn btn-secondary"
                                                onClick={() => handleRemoveTasbeeh(item.key)}
                                                style={{ float: "right", marginTop: "-35px" }}
                                            >
                                                Delete
                                            </button>
                                        )}
                                    </div>
                                    <hr />
                                    <div>
                                        <div className="text-center my-4">
                                            <div
                                                style={{
                                                    background: "linear-gradient(135deg, #ffffff 0%, #e0f7fa 100%)",
                                                    color: "#4caf50",
                                                    borderRadius: "50%",
                                                    width: "200px",
                                                    height: "200px",
                                                    lineHeight: "200px",
                                                    fontSize: "48px",
                                                    fontWeight: "bold",
                                                    margin: "0 auto",
                                                    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                }}
                                                onClick={() => handleIncrement(item.key)}
                                            >
                                                {state.counts[item.key] || 0}
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="text-center mt-2">
                                            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                                                <button
                                                    className="text-white px-4 py-2"
                                                    style={{
                                                        background: "linear-gradient(135deg, #f44336 0%, #e57373 100%)",
                                                        borderRadius: "20px",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                        transition: "background 0.3s",
                                                        padding: "15px",
                                                    }}
                                                    onClick={() => handleDecrement(item.key)}
                                                >
                                                    Decrease
                                                </button>
                                                <button
                                                    className="text-white px-4 py-2"
                                                    style={{
                                                        background: "linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)",
                                                        borderRadius: "20px",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                        transition: "background 0.3s",
                                                        padding: "15px",
                                                    }}
                                                    onClick={() => handleReset(item.key)}
                                                >
                                                    Reset
                                                </button>
                                                <button
                                                    className="text-white px-4 py-2"
                                                    style={{
                                                        background: "linear-gradient(135deg, #4caf50 0%, #81c784 100%)",
                                                        borderRadius: "20px",
                                                        fontSize: "16px",
                                                        fontWeight: "bold",
                                                        border: "none",
                                                        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                        transition: "background 0.3s",
                                                        padding: "15px",
                                                    }}
                                                    onClick={() => handleSetGoal(item.key)}
                                                >
                                                    Set Goal
                                                </button>
                                            </div>
                                            {state.goals[item.key] && (
                                                <div className="mt-2" style={{ fontSize: "16px", color: "#4caf50" }}>
                                                    <hr />
                                                    Goal: {state.goals[item.key]} - Remaining: {Math.max(state.goals[item.key] - (state.counts[item.key] || 0), 0)}
                                                    <br />
                                                    <button
                                                        className="text-white px-2 py-1 ms-2"
                                                        style={{
                                                            background: "linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)",
                                                            borderRadius: "15px",
                                                            fontSize: "18px",
                                                            fontWeight: "bold",
                                                            border: "none",
                                                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                                                            transition: "background 0.3s",
                                                            marginTop: "10px",
                                                        }}
                                                        onClick={() => handleRemoveGoal(item.key)}
                                                    >
                                                        Remove Goal
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <Dialog open={showModal} onClose={() => setShowModal(false)}>
                <DialogTitle>Add New Dhikr</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 300, padding: 2 }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="tasbeeh-text"
                            label="Dhikr Text"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={newTasbeeh}
                            onChange={(e) => setNewTasbeeh(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowModal(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleAddTasbeeh} color="primary" variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={showGoalModal} onClose={() => setShowGoalModal(false)}>
                <DialogTitle>Set Goal for Dhikr</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 300, padding: 2 }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="goal-value"
                            label="Number of Dhikr Required"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={goalValue}
                            onChange={(e) => setGoalValue(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    {state.goals[currentGoalTasbeeh] && (
                        <Button
                            onClick={() => {
                                handleRemoveGoal(currentGoalTasbeeh);
                                setShowGoalModal(false);
                            }}
                            color="error"
                        >
                            Remove Goal
                        </Button>
                    )}
                    <Button onClick={() => setShowGoalModal(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleSaveGoal} color="primary" variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};
export default TallyCounterEN;